import { INetworkConfig, Instance } from '@/api/instance'
import { IResponse } from '@/api/types'
import { IGetCourseRequest } from '@/stores/rating/types'
import { Endpoints } from '../endpoints'
import {
  GetFilterObjects,
  GetRatingReq,
  GetRatingRes,
  IRatingCategories,
  IRatingCourses,
  IRatingLevelByCategories,
  TGetBranchResponse,
} from './types'

const config: INetworkConfig = {
  baseURL: Endpoints.Base,
}

class RatingApi extends Instance {
  constructor(config: INetworkConfig) {
    super(config)
  }

  getRatingCategories = (): Promise<IResponse<IRatingCategories>> => this.get(Endpoints.Categories)

  getRating = (params: GetRatingReq): Promise<IResponse<GetRatingRes>> => this.get(Endpoints.Rating, { params })

  getLevelByCategory = (): Promise<IResponse<IRatingLevelByCategories>> => this.get(Endpoints.LevelsByCategory)

  getCourses = (params?: IGetCourseRequest): Promise<IResponse<IRatingCourses>> =>
    this.get(Endpoints.Courses, { params })

  getBranches = (): Promise<IResponse<TGetBranchResponse>> => this.get(Endpoints.Offices)

  getFilterObjects = (): Promise<IResponse<GetFilterObjects>> =>
    this.get(Endpoints.FilterObjects, { params: { page: 1, perPage: 100 } })
}

export const ratingApi = new RatingApi(config)
